export const get = property => state => state[property];
